// extracted by mini-css-extract-plugin
export default {"inside":"u90fR","outside":"G_uey","wings":"hOvQ6"};